<template>
  <div>
    <div class="modelReg__title">
      <h3>
        {{ $t('modal.modalStateEnum.RestorePasswordSuccessfully.title') }}
      </h3>
      <p>
        {{ $t('modal.modalStateEnum.RestorePasswordSuccessfully.subTitle') }}
        {{ form.email }}
      </p>
    </div>

    <div class="modelReg__alertLoading" v-if="loader"></div>
    <div class="modelReg__alertError" v-if="errorMessage">{{ errorMessage }}</div>
    <div class="modelReg__alertSuccess" v-if="successMessage">{{ successMessage }}</div>

    <div class="modelReg__grid-btn">
      <UiBaseButton
        size="xxl"
        :label="$t('modal.modalStateEnum.RestorePasswordSuccessfully.btnResend')"
        @click="sendEmailAgain"
      ></UiBaseButton>
      <UiBaseButton
        v-if="!storeAuth.isLoggedIn"
        size="xxl"
        :label="$t('modal.modalStateEnum.RestorePasswordSuccessfully.btnChangeEmail')"
        variant="soft"
        @click="changeEmail"
      ></UiBaseButton>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { modalStateEnum } from '@shared/model';
import apiAuth from '~/entities/auth';
import { useResponseStatusesState } from '@shared/lib';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const { responseStatusesState } = useResponseStatusesState();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: {
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    },
  },
});
const form = ref(props.userData);
const loader = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);

const sendEmailAgain = () => {
  const params = {
    email: form.value.email,
  };

  loader.value = true;
  loader.value = true;
  apiAuth
    .forgotPassword(params)
    .then((data) => {
      const responseCode = data.code;
      successMessage.value = responseStatusesState[responseCode];
    })
    .catch((error) => {
      const responseCode = error.data.code || 5000;
      errorMessage.value = responseStatusesState[responseCode];
    })
    .finally(() => {
      loader.value = false;
      setTimeout(() => {
        errorMessage.value = null;
        successMessage.value = null;
      }, 6000);
    });
};

const changeEmail = () => {
  storeModal.stateAuthModal(modalStateEnum.RestorePassword);
};
</script>

<style scoped lang="scss"></style>


